//Start Vue js

if(document.querySelector('#my-events')) {
    require('../../vue/roots/TheMyEvents.js')
}